import styled from "styled-components";
import { viewSizes } from "./variables";

export const ImgWrapper = styled.img`
  width: 100%;
  @media only screen and (max-width: ${viewSizes.mobile}) {
    object-fit: cover;
    height: 50vw;
  }
`;
